import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Card } from "reactstrap";
import { Link, RouteComponentProps } from "react-router-dom";

import { BreadCrumb } from "../../components/Common";

const reports = [
  {
    title: "subscriptions",
    description: "subscription_report_description",
    action: "",
  },
];

type TProps = RouteComponentProps & {};
export const ReportsPage: React.FC<TProps> = () => {
  //#region hooks
  const { t } = useTranslation();
  //#endregion

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("reports")} pageTitle={t("reports")} />
          <Row>
            {reports.map((report, index) => (
              <Col
                key={index.toString()}
                className="col-md-6 col-lg-4 col-xl-3 "
              >
                <Card>
                  <div className="card-body">
                    <h4 className="mt-2 mb-1">{t(report.title)}</h4>
                    <p className="text-muted">{t(report.description)}</p>
                    <br />
                    <Link
                      className={"btn btn-success w-100"}
                      to={"/reports/subscription"}
                    >
                      {t("generate")}
                    </Link>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
